import React, { useEffect, useState } from 'react';
import { useTranslation } from '../hooks/useTranslation.js';
import { KEYCLOAK_ACCOUNT_CONSOLE, fetchCurrentUser, signInUrl, signOutUrl } from '../utils/authClient.js';

// Who is signed in, and the way to Keycloak's account console, where the
// person changes password, second factor, sessions and mail address.
const AccountPage = () => {
  const { t } = useTranslation();
  const [session, setSession] = useState({ loading: true, user: null });

  useEffect(() => {
    let cancelled = false;
    fetchCurrentUser()
      .then((payload) => {
        if (!cancelled) setSession({ loading: false, user: payload.user });
      })
      .catch(() => {
        if (!cancelled) setSession({ loading: false, user: null });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const { loading, user } = session;
  const roleLabels = t.admin.roleLabels || {};
  // Only the roles the platform assigns; Keycloak's built-in roles
  // (default-roles-…, offline_access) mean nothing to the person.
  const roles = (user?.roles || []).filter((role) => roleLabels[role]).map((role) => roleLabels[role]);
  const lead = loading ? t.auth.validating : (user ? t.account.manageText : t.account.signedOut);

  return (
    <main className="site-main">
      <section className="site-hero site-hero--single">
        <div className="site-hero__copy">
          <h1 className="site-title">{t.nav.account}</h1>
          <p className="site-lead">{lead}</p>
          {!loading && !user ? (
            <div className="account-actions">
              <a className="homepage-button-primary" href={signInUrl()}>{t.nav.login}</a>
            </div>
          ) : null}
          {user ? (
            <div className="account-actions">
              <a className="homepage-button-primary" href={KEYCLOAK_ACCOUNT_CONSOLE}>{t.account.manageButton}</a>
              <a className="homepage-button-secondary" href={signOutUrl()}>{t.nav.logout}</a>
            </div>
          ) : null}
        </div>
      </section>

      {user ? (
        <dl className="account-facts">
          <div className="account-facts__row">
            <dt>{t.account.username}</dt>
            <dd>{user.username}</dd>
          </div>
          {user.email ? (
            <div className="account-facts__row">
              <dt>{t.account.email}</dt>
              <dd>{user.email}</dd>
            </div>
          ) : null}
          {roles.length ? (
            <div className="account-facts__row">
              <dt>{t.account.roles}</dt>
              <dd>{roles.join(', ')}</dd>
            </div>
          ) : null}
        </dl>
      ) : null}
    </main>
  );
};

export default AccountPage;
